var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"row home-page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box"},[_c('h4',{staticClass:"page-title-left mt-4"},[_vm._v("Vocento Dashboard ")])])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{ref:"embeddingContainer"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }